(() => {
  if (window.CAJVariantImageSwitching) return;
  window.CAJVariantImageSwitching = true;

  const clearSizeGuidePlaceholders = () => {
    document.querySelectorAll('[data-caj-size-guide-standalone]').forEach((container) => {
      const nearestProductInfo = container.closest('product-info');
      const isCurrentProductInfo = !nearestProductInfo || nearestProductInfo.id?.startsWith('MainProduct-');
      if (!isCurrentProductInfo || container.childElementCount > 0) return;
      container.innerHTML = '';
    });
  };

  const normalize = (value) =>
    String(value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();

  const optionNameFromTarget = (target) => {
    const directName = normalize(target?.getAttribute?.('name'));
    if (directName) return directName;

    const wrapper = target?.closest?.('.product-form__input');
    const legend = wrapper?.querySelector?.('legend.form__label');
    const labelText = normalize(legend?.textContent);
    return labelText;
  };

  const isSizeOrColorOption = (target) => {
    const name = optionNameFromTarget(target);
    return (
      name.includes('size') ||
      name.includes('color') ||
      name.includes('colour') ||
      name.includes('مقاس') ||
      name.includes('المقاس') ||
      name.includes('لون') ||
      name.includes('اللون')
    );
  };

  const featureEnabled = () => {
    const settings = document.querySelector('[data-caj-variant-image-settings]');
    return !settings || settings.dataset.enabled !== 'false';
  };

  clearSizeGuidePlaceholders();
  document.addEventListener('shopify:section:load', clearSizeGuidePlaceholders);

  document.addEventListener(
    'change',
    (event) => {
      const productInfo = event.target.closest?.('product-info');
      const variantSelects = event.target.closest?.('variant-selects');
      if (!productInfo || !variantSelects || !productInfo.id?.startsWith('MainProduct-')) return;

      productInfo.dataset.cajVariantImageEligible = isSizeOrColorOption(event.target) ? 'true' : 'false';
    },
    true
  );

  customElements.whenDefined('product-info').then(() => {
    const ProductInfo = customElements.get('product-info');
    if (!ProductInfo || ProductInfo.prototype.__cajVariantImageSwitchingApplied) return;

    const originalUpdateMedia = ProductInfo.prototype.updateMedia;
    if (typeof originalUpdateMedia !== 'function') return;

    ProductInfo.prototype.__cajVariantImageSwitchingApplied = true;

    ProductInfo.prototype.updateMedia = function (html, variantFeaturedMediaId) {
      if (!this.id?.startsWith('MainProduct-')) {
        return originalUpdateMedia.call(this, html, variantFeaturedMediaId);
      }

      const eligible = this.dataset.cajVariantImageEligible;
      delete this.dataset.cajVariantImageEligible;

      if (!featureEnabled()) return;
      if (eligible === 'false') return;
      if (!variantFeaturedMediaId) return;

      return originalUpdateMedia.call(this, html, variantFeaturedMediaId);
    };
  });
})();
